export default {
  EXTRA_LARGE_TEXT_FIELDS: 900,
  EXTRA_TEXT_FIELDS: 600,
  LARGE_TEXT_FIELDS: 300,
  AVERAGE_TEXT_FIELDS: 60,
  SMALL_TEXT_FIELDS: 32,
  TINY_TEXT_FIELDS: 8,
}
